import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { addDays } from '@mkcore/shared';
import { Button, PageHeader, buttonVariants } from '@mkcore/ui';
import { formatDate } from '@/lib/format';
import { DayProposal } from '@/features/time/day-proposal';

export const Route = createFileRoute('/_app/time/day/$date')({ component: DayPage });

/** One day to close (CO-1396): the day proposal with its own day navigation; the list of the day stays on /time. */
function DayPage() {
  const { t } = useTranslation();
  const { date } = Route.useParams();
  const navigate = useNavigate();
  const go = (d: string) => void navigate({ to: '/time/day/$date', params: { date: d } });
  return (
    <>
      <PageHeader
        title={t('time.day.titleFor', { date: formatDate(date) })}
        description={t('time.day.description')}
        actions={
          <div className="flex items-center gap-2">
            <Button variant="ghost" size="icon" aria-label={t('time.prevDay')} onClick={() => go(addDays(date, -1))}>
              <ChevronLeft />
            </Button>
            <Button variant="ghost" size="icon" aria-label={t('time.nextDay')} onClick={() => go(addDays(date, 1))}>
              <ChevronRight />
            </Button>
            <Link to="/time/week" search={{ date }} className={buttonVariants({ variant: 'secondary', size: 'sm' })}>
              {t('time.week.title')}
            </Link>
          </div>
        }
      />
      <DayProposal date={date} />
    </>
  );
}
